module.exports = __webpack_public_path__ + "static/media/joundfloatflipped.77359766.png";